import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ChildrenAttendingClasses = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children attending classes >=80% (%)" />
    </Box>
  );
};
